// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import Link, { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import constants from "@store/constants";
import Note from "@store/Library/Components/Icons/Note";
import { linkGetButtonLinkProps } from "@store/Themes/common/props/link";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC, useMemo } from "react";
import { css } from "styled-components";

export interface RequestQuoteButtonPresentationProps extends ExpandStyles<RequestQuoteButtonStyles> {}

export interface RequestQuoteButtonProps extends RequestQuoteButtonPresentationProps {
    productId?: string;
    showIcon?: boolean;
    isButtonLink?: boolean;
}

export interface RequestQuoteButtonStyles {
    button?: ButtonPresentationProps;
    link?: LinkPresentationProps;
}

export const requestQuoteButtonStyles: RequestQuoteButtonStyles = {
    button: {
        variant: "primary",
        mergeCss: true,
        icon: { position: "left", src: Note },
        css: css`
            flex-grow: 1;

            ${breakpoint("sm")} {
                flex-grow: 0;
            }
        `,
    },
    link: linkGetButtonLinkProps(Note),
};

const RequestQuoteButton: FC<RequestQuoteButtonProps> = ({
    extendedStyles,
    overridedStyles,
    productId,
    showIcon = true,
    isButtonLink = false,
}) => {
    const simpleQuotePageUrl = usePageLinkByPageType(constants.pageType.simpleQuote)?.url;
    const styles = useExpandProps(requestQuoteButtonStyles, extendedStyles, overridedStyles);
    const buttonStyles = useMemo(() => {
        if (!showIcon) {
            return { ...styles.button, icon: undefined };
        }
        return styles.button;
    }, [showIcon, styles.button]);

    const linkStyles = useMemo(() => {
        if (!showIcon) {
            return { ...styles.link, icon: undefined };
        }
        return styles.link;
    }, [showIcon, styles.link]);

    if (!simpleQuotePageUrl) {
        return null;
    }

    const redirectUrl = `${simpleQuotePageUrl}${productId ? `?${constants.queryStringParameters.referenceProductId}=${productId}` : ""}`;

    if (isButtonLink) {
        return (
            <Link {...linkStyles} href={redirectUrl}>
                {translate("Request A Quote")}
            </Link>
        );
    }

    return (
        <Button {...buttonStyles} href={redirectUrl}>
            {translate("Request A Quote")}
        </Button>
    );
};

export default RequestQuoteButton;
